import type { JSX } from 'react';
import { useAddCapability } from '@doxyme/extensions-bridge-react';
import {
  BackendCapability,
  PlaySoundCapability,
  StorageCapability,
} from '@doxyme/extensions-bridge';
import { ExtensionsModal } from '../extensionsModal';
import { ExtensionsHeadless } from '../extensionsHeadless';
import { ExtensionsOverlayApplet } from '../extensionsOverlayApplet';
import { ExtensionsNavigationConfirmationAlert } from '../extensionsNavigationConfirmationAlert';
import { bridge } from '../../../features/extensions/instances';
import {
  useExtensionsMultiplayerRoom,
  useExtensionsNotification,
  useExtensionsAlertBanner,
  useExtensionsAddAppEvents,
} from '../../../hooks/useExtensions';
import { ExtensionsReceiveContext } from '../extensionsReceiveContext';

/**
 * Adds initial capabilities, that are common for provider and patient.
 */
export const ExtensionsInitCapabilities = (): JSX.Element => {
  useAddCapability(bridge, () => new StorageCapability());
  useAddCapability(bridge, () => new BackendCapability());
  useAddCapability(bridge, () => new PlaySoundCapability());
  useExtensionsNotification();
  useExtensionsMultiplayerRoom();
  useExtensionsAlertBanner();
  useExtensionsAddAppEvents();

  return (
    <>
      <ExtensionsReceiveContext />
      <ExtensionsModal />
      <ExtensionsHeadless />
      <ExtensionsOverlayApplet />
      <ExtensionsNavigationConfirmationAlert />
    </>
  );
};
